import React from 'react';

export default function NavRate({ rate }: { rate: number }) {
  return (
    <div className="w-[47px] h-[18px] flex items-center justify-center bg-[#FFF6ED] border border-[#FFD1A9] rounded-[6px] gap-1">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.56117 2.34781L8.69401 4.63272C8.77918 4.80481 8.94368 4.92382 9.13443 4.95124L11.7495 5.32921C12.229 5.39862 12.4203 5.98663 12.0732 6.3238L10.1827 8.15839C10.0444 8.29256 9.98139 8.48564 10.0141 8.67522L10.4463 11.1859C10.5338 11.6951 9.99888 12.0836 9.54038 11.8439L7.27242 10.6568C7.10209 10.5676 6.89907 10.5676 6.72932 10.6568L4.46306 11.8427C4.00398 12.083 3.46729 11.694 3.55538 11.1835L3.98768 8.67522C4.02035 8.48564 3.95731 8.29256 3.81906 8.15839L1.9285 6.3238C1.58083 5.98663 1.77212 5.39862 2.25221 5.32921L4.86731 4.95124C5.05747 4.92382 5.22198 4.80481 5.30773 4.63272L6.44057 2.34781C6.66865 1.88406 7.33133 1.88406 7.56117 2.34781Z"
          fill="#FB6011"
        />
      </svg>
      <div className="text-[#FB6011] text-[12px] font-semibold font-['DM_Sans']">
        {rate}
      </div>
    </div>
  );
}
